import { useEffect } from 'react';
import { onCLS, onINP, onLCP, onFCP, onTTFB, type Metric } from 'web-vitals';

const sendToGoogleAnalytics = (metric: Metric) => {
  if (typeof window.gtag !== 'function') {
    console.log(`[Web Vitals] ${metric.name}: ${metric.value.toFixed(2)} (${metric.rating}) - GA not available`);
    return;
  }

  // Enviar para Google Analytics 4
  window.gtag('event', metric.name, {
    value: Math.round(metric.name === 'CLS' ? metric.delta * 1000 : metric.delta),
    metric_id: metric.id,
    metric_value: metric.value,
    metric_delta: metric.delta,
    metric_rating: metric.rating, // 'good' | 'needs-improvement' | 'poor'
    non_interaction: true,
  });

  // Log para debug
  const color = metric.rating === 'good' ? '🟢' : metric.rating === 'needs-improvement' ? '🟡' : '🔴';
  console.log(`[Web Vitals] ${color} ${metric.name}: ${metric.value.toFixed(2)} (${metric.rating})`);
};

export const useWebVitals = () => {
  useEffect(() => {
    // Core Web Vitals (afetam ranking do Google)
    onCLS(sendToGoogleAnalytics);  // Cumulative Layout Shift
    onINP(sendToGoogleAnalytics);  // Interaction to Next Paint
    onLCP(sendToGoogleAnalytics);  // Largest Contentful Paint

    // Métricas adicionais (úteis para debug)
    onFCP(sendToGoogleAnalytics);  // First Contentful Paint
    onTTFB(sendToGoogleAnalytics); // Time to First Byte
  }, []);
};
